module.exports = __webpack_public_path__ + "img/climbers.41a784ff.png";